var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspGlutenFree = function SvgUspGlutenFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 71 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0005 49.9866L50.7578 45.744",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5549 49.8267C43.0942 49.8226 43.6261 49.7002 44.113 49.4683C44.6 49.2363 45.0301 48.9004 45.3731 48.4842C45.7161 48.0679 45.9636 47.5815 46.0983 47.0592C46.2329 46.537 46.2513 45.9915 46.1522 45.4613C46.1473 44.922 46.0243 44.3903 45.7919 43.9036C45.5595 43.417 45.2233 42.9871 44.807 42.6442C44.3907 42.3013 43.9043 42.0538 43.3821 41.919C42.8599 41.7842 42.3145 41.7654 41.7842 41.864C39.0376 42.1307 33.9949 44.416 34.2082 46.616C34.4216 48.816 39.8002 50.0933 42.5549 49.8267V49.8267Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5495 39.824C33.0889 39.8199 33.6207 39.6976 34.1077 39.4656C34.5946 39.2337 35.0247 38.8977 35.3677 38.4815C35.7107 38.0653 35.9583 37.5789 36.0929 37.0566C36.2275 36.5343 36.2459 35.9888 36.1468 35.4587C36.1432 34.9192 36.0212 34.3871 35.7894 33.8999C35.5576 33.4127 35.2216 32.9824 34.8053 32.6393C34.389 32.2962 33.9024 32.0487 33.3799 31.9143C32.8574 31.7798 32.3118 31.7618 31.7815 31.8613C29.0322 32.128 23.9895 34.4133 24.2028 36.6107C24.4162 38.808 29.8028 40.088 32.5495 39.824Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.84 37.5333C54.8373 38.0741 54.7156 38.6077 54.4837 39.0963C54.2518 39.5849 53.9153 40.0165 53.498 40.3605C53.0807 40.7046 52.5928 40.9526 52.0689 41.0871C51.5451 41.2215 50.998 41.2391 50.4666 41.1386C49.9273 41.1337 49.3956 41.0107 48.909 40.7783C48.4223 40.5459 47.9924 40.2097 47.6495 39.7934C47.3067 39.3771 47.0591 38.8907 46.9243 38.3685C46.7895 37.8463 46.7708 37.3009 46.8693 36.7706C47.136 34.0239 49.4213 28.9813 51.6213 29.1919C53.8213 29.4026 55.1066 34.7919 54.84 37.5333Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8372 27.536C44.8331 28.0753 44.7108 28.6072 44.4788 29.0941C44.2469 29.581 43.9109 30.0112 43.4947 30.3542C43.0785 30.6972 42.592 30.9447 42.0698 31.0793C41.5475 31.2139 41.002 31.2324 40.4718 31.1333C39.9317 31.1308 39.3987 31.0097 38.9105 30.7784C38.4224 30.5471 37.991 30.2113 37.647 29.7948C37.3031 29.3783 37.0548 28.8913 36.92 28.3682C36.7851 27.8452 36.7668 27.2989 36.8665 26.768C37.1332 24.0186 39.4185 18.976 41.6158 19.1893C43.8132 19.4026 45.1038 24.7866 44.8372 27.536Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9574 20.288C31.3714 20.6339 31.7043 21.0664 31.9328 21.5551C32.1613 22.0437 32.2797 22.5766 32.2797 23.116C32.2797 23.6554 32.1613 24.1883 31.9328 24.6769C31.7043 25.1656 31.3714 25.5981 30.9574 25.944C30.6115 26.3579 30.179 26.6909 29.6904 26.9194C29.2017 27.1479 28.6689 27.2663 28.1294 27.2663C27.59 27.2663 27.0572 27.1479 26.5685 26.9194C26.0799 26.6909 25.6473 26.3579 25.3014 25.944C23.3494 23.992 20.9121 19.0107 22.4721 17.4587C24.0321 15.9067 29.0054 18.3333 30.9574 20.288V20.288Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 62.9626C55.5685 62.9626 69 49.5312 69 32.9626C69 16.3941 55.5685 2.96265 39 2.96265C22.4315 2.96265 9 16.3941 9 32.9626C9 49.5312 22.4315 62.9626 39 62.9626Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2133 11.7493L53 18.9627",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7891 54.1706L24.9997 46.9626",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspGlutenFree;